import CGRScore from './CGRScore';

export default CGRScore;
